import React from 'react'

import { TopImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Mobile: React.FC<SectionProps> = ({ copy }) => {
  const { mobile_devices_overview: mobileDevicesCopyContent } = copy
  return (
    <React.Fragment>
      <Text content={mobileDevicesCopyContent.mobile_devices_overview_header_text} />
      <TopImageContent
        altImage={mobileDevicesCopyContent.alt_image_add_mobile_devices}
        content={
          <React.Fragment>
            <Text content={mobileDevicesCopyContent.mobile_devices_overview_subheader} />
            <List
              items={[
                buildDynamicCopy(
                  mobileDevicesCopyContent.mobile_devices_overview_step1,
                  <b>{mobileDevicesCopyContent.icon_mobile_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  mobileDevicesCopyContent.mobile_devices_overview_step2,
                  <b>{mobileDevicesCopyContent.generate_access_code_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  mobileDevicesCopyContent.mobile_devices_overview_step3,
                  <b>{mobileDevicesCopyContent.ios_bold_text}</b>,
                  <b>{mobileDevicesCopyContent.android_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  mobileDevicesCopyContent.mobile_devices_overview_step4,
                  <b>{mobileDevicesCopyContent.access_code_bold_text}</b>,
                ) as React.ReactNode,
              ]}
              listType="ol"
            />
            <Text content={mobileDevicesCopyContent.mobile_devices_overview_success} />
          </React.Fragment>
        }
        image={HELP_IMAGES.MOBILE_ADD_MOBILE_DEVICE}
        imageLargeBreakPoint={10}
        sx={{ mt: 20 }}
      />
      <SectionTitle
        content={mobileDevicesCopyContent.preventing_app_crashes_section_title}
        sx={{ pt: 48 }}
      />
      <Text content={mobileDevicesCopyContent.preventing_app_crashes_subheader} />
      <List
        items={[
          buildDynamicCopy(
            mobileDevicesCopyContent.preventing_app_crashes_step1,
            <b>{mobileDevicesCopyContent.update_bold_text}</b>,
          ) as React.ReactNode,
          buildDynamicCopy(
            mobileDevicesCopyContent.preventing_app_crashes_step2,
            <b>{mobileDevicesCopyContent.close_bold_text}</b>,
          ) as React.ReactNode,
          buildDynamicCopy(
            mobileDevicesCopyContent.preventing_app_crashes_step3,
            <b>{mobileDevicesCopyContent.restart_bold_text}</b>,
          ) as React.ReactNode,
          buildDynamicCopy(
            mobileDevicesCopyContent.preventing_app_crashes_step4,
            <b>{mobileDevicesCopyContent.reinstall_bold_text}</b>,
          ) as React.ReactNode,
        ]}
      />
      <Text content={mobileDevicesCopyContent.preventing_app_crashes_footer} />
    </React.Fragment>
  )
}

export default Mobile
